/* eslint-disable max-len */
import React from 'react';

const Policy = () => (
  <svg width="18" height="21" viewBox="0 0 18 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2.54167 3.34211V18.3816H15.875V20.0526H2.54167C1.625 20.0526 0.875 19.3007 0.875 18.3816V3.34211H2.54167ZM11.7083 5.84869H16.2917L11.7083 1.25329V5.84869ZM5.875 0H12.5417L17.5417 5.01316V15.0395C17.5417 15.9669 16.8 16.7105 15.875 16.7105H5.875C5.43297 16.7105 5.00905 16.5345 4.69649 16.2211C4.38393 15.9077 4.20833 15.4827 4.20833 15.0395V1.67105C4.20833 0.743619 4.95 0 5.875 0ZM13.375 13.3684V11.6974H5.875V13.3684H13.375ZM15.875 10.0263V8.35527H5.875V10.0263H15.875Z" fill="black" />
  </svg>
);

export default Policy;
